module.exports = __webpack_public_path__ + "img/coupon2022f2.8f91e30d.jpg";